module.exports = __webpack_public_path__ + "img/aaron-tp.6f8038b5.jpg";